import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import ServiceArea from "../components/ServiceArea";
import CTA from "../components/CTA";
import BottomCall from "../components/BottomCall";
import PopupCall from "../components/PopupCall";
import WhyChooseUs from "../components/WhyChoosePage";
import AreaCarousel from "../components/AreaCarousel";
import Reviews from "../components/Reviews";

export default function Home() {
  return (
    <>

      <BottomCall />
      <PopupCall />
      <Hero />
      <Services />
      <WhyChooseUs />
      <AreaCarousel />
      <ServiceArea />
      <CTA />
      <Reviews />
     
    </>
  );
}